import http from 'http'
import filter from 'src/utils/filter'
import server from 'src/utils/server'

export const postLogin = (email, password) => {
  return http.post(server.url_to('auth_user'), { 'email': email, 'password': password, 'full': true })
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const postLoginWithSubdomain = (email, password, subdomain) => {
  return http.post(server.url_to('auth_user_with_subdomain', subdomain), { 'email': email, 'password': password, 'subdomain': subdomain, 'full': true })
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const postAdmLogin = (params) => {
  return http.post(server.url_to('auth_admin'), { 'email': params.email, 'password': params.password })
  .catch(function (error) {
    return error.response
  })
}

export const postCustomerLogin = (email, password) => {
  return http.post(server.url_to('auth_customer'), { 'email': email, 'password': password })
  .catch(function (error) {
    return error.response
  })
}

export const getCustomerData = (id) => {
  return http.get(server.url_to('/customers/' + id), { data: { requestType: 'customer' } })
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const newCustomer = (params) => {
  return http.post(server.url_to('customers'), params)
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error
  })
}

export const updateCustomer = (params) => {
  return http.put(server.url_to('customers/' + params.customer.id), params)
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error
  })
}

export const resetPassword = (email) => {
  return http.get(server.url_to('users/recover_password?') + filter.toQuery({ 'email': email }))
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error
  })
}

export const updatePassword = (params) => {
  return http.patch(server.url_to('users/reset_password'), params)
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error
  })
}

export const getUser = (id) => {
  return http.get(server.url_to_user(id))
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const getSeller = () => {
  return http.get(server.url_to_me())
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const logoutYapayLogin = (token) => {
  return http.delete(process.env.URL_YAPAY_LOGOUT, { headers: { 'Authorization': `Bearer ${token}` } })
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/services.js